import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { onIncomingCallMessage } from 'modules/conference/actions/_newConversationActions/onIncomingCall';

const propTypes = {
  onIncomingCallMessage: PropTypes.func.isRequired,
};

const WebviewListeners = ({
  onIncomingCallMessage,
}) => {
  const handleReactNativeEvent = event => {
    const message = JSON.parse(event.data);
    switch (message.action) {
      case 'RN_CONNECT_TO_CONSULTATION':
        return onIncomingCallMessage(message.data);
      default:
        break;
    }
  };

  useEffect(() => {
    document.addEventListener('message', handleReactNativeEvent);

    return () => {
      document.removeEventListener('message', handleReactNativeEvent);
    };
  }, []);

  return null;
};

WebviewListeners.propTypes = propTypes;

export default connect(null, {
  onIncomingCallMessage,
})(WebviewListeners);
